import { Button, TextField, ValidationMessage } from '@huntington/honeycomb';
import { Box, Typography } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGenerateOTPMutation } from '../../../api/user.api';
import { useGetCsrfTokenQuery } from '../../../api/auth.api';
import {
	ENROLLMENT_START_CONTINUE_BUTTON,
	ENROLLMENT_START_DESCRIPTION,
	ENROLLMENT_START_EMAIL_ERROR,
	ENROLLMENT_START_TITLE,
} from '../../../constants/messages';
import { emailRegex } from '../../../hooks/useFormHook';
import { ROUTE_ENROLLMENT, ROUTE_VERIFY_OTP } from '../../../router/router';

export default function EnrollmentStart() {
	const [email, setEmail] = useState('');
	const [error, setError] = useState('');
	const navigate = useNavigate();
	const [generateOtp] = useGenerateOTPMutation();
	// Establish CSRF token for unauthenticated users
	useGetCsrfTokenQuery();

	const handleValidate = async () => {
		// If user tries to submit an empty email, error message is shown
		if (!email.trim()) {
			setError(ENROLLMENT_START_EMAIL_ERROR);
			return;
		}

		// Validate email format with regex
		if (!emailRegex.test(email)) {
			setError(ENROLLMENT_START_EMAIL_ERROR);
			return;
		}

		// Clear any previous errors before validation
		setError('');

		// Generate and send OTP to user's email
		// The endpoint always returns 200 to prevent account enumeration; any error is a
		// server/transport failure that should surface the same generic message.
		try {
			await generateOtp({ emailId: email }).unwrap();
			navigate(`${ROUTE_ENROLLMENT}/${ROUTE_VERIFY_OTP}`, { state: { email } });
		} catch {
			setError(ENROLLMENT_START_EMAIL_ERROR);
		}
	};

	return (
		<Box>
			<Typography
				variant="h1"
				component="h1"
				gutterBottom
				sx={{ font: 'bold 2.25rem "Huntington Serif", serif' }}
			>
				{ENROLLMENT_START_TITLE}
			</Typography>

			<Box>
				<Typography gutterBottom sx={{ paddingBottom: '1rem' }}>
					{ENROLLMENT_START_DESCRIPTION}
				</Typography>

				<TextField
					label="Email Address"
					name="email"
					type="email"
					required
					fullWidth
					value={email}
					onChange={(e) => setEmail(e.target.value)}
					error={!!error}
				/>

				{error && (
					<ValidationMessage id="validation-message" sx={{ mt: '0.25rem' }}>
						<span>{error}</span>
					</ValidationMessage>
				)}

				<Box
					sx={{
						display: 'flex',
						justifyContent: 'flex-end',
						alignItems: 'center',
						marginTop: '1.5rem',
						alignSelf: 'stretch',
					}}
				>
					<Button onClick={handleValidate}>{ENROLLMENT_START_CONTINUE_BUTTON}</Button>
				</Box>
			</Box>
		</Box>
	);
}
